import { CityCard } from './CityCard';
import { QuickAccess } from './QuickAccess';
import {
    type LandingContents,
    type LandingContentsDefaultTabEnum,
    type LandingContentsFaqsInner,
    type LandingContentsLinkBoxInner,
    type LandingContentsParentEnum,
    LandingContentsQuickAccessLayoutEnum,
} from '@clients/ContentApi';
import { type SearchMode } from '@utils/types';
import { type ReserveType } from '@utils/itinerary';
import { ParentReserveTypes } from '@store/content/entities/types';
import { toAbsoluteSrc } from '@store/content';

export default class LandingContent {
    constructor(data: LandingContents) {
        this.h1 = data.h1Title ?? '';
        this.title = data.customPageTitle ?? '';
        this.cityName = data.cityName ?? '';
        this.provinceName = data.provinceName ?? '';
        this.description = data.customPageDescription ?? '';
        this.parent = data.parent;
        if (data.parent) {
            this.parentReserveType = ParentReserveTypes[data.parent];
        }
        this.url = data.url;
        this.body = data.body;
        this.faqs = data.faqs || [];
        this.linkBox = data.linkBox?.slice(0, 20) || [];
        this.mode = data.mode as SearchMode;
        this.defaultTab = data.defaultTab;
        this.redirectUrl = data.redirectUrl;
        this.redirectErrorCode = data.redirectErrorCode;
        this.hideAdvantage = data.HideAdvantages;
        this.cityCards = data.CityCards?.map(card => new CityCard(card)) ?? [];
        this.cityCardsTitle = data.CityCardTitle;
        this.quickAccessItems =
            data.QuickAccessItems?.map(access => new QuickAccess(access)) || [];
        this.quickAccessLayout =
            data?.QuickAccessLayout ||
            LandingContentsQuickAccessLayoutEnum.DoubleRow;
        this.ogImage = toAbsoluteSrc(data?.ogImage?.url);
        this.ogImageAlt = data?.ogImage?.alternativeText;
    }

    h1: string;
    title: string;
    cityName: string;
    provinceName: string;
    description: string;
    parent?: LandingContentsParentEnum;
    parentReserveType?: ReserveType;
    url: string;
    body?: string;
    faqs: LandingContentsFaqsInner[];
    linkBox: LandingContentsLinkBoxInner[];
    mode?: SearchMode;
    defaultTab?: LandingContentsDefaultTabEnum;
    redirectUrl?: string;
    redirectErrorCode?: number;
    cityCardsTitle?: string;
    ogImage?: string;
    ogImageAlt?: string;
    hideAdvantage?: boolean;
    cityCards: CityCard[];
    quickAccessItems: QuickAccess[] = [];
    quickAccessLayout: LandingContentsQuickAccessLayoutEnum =
        LandingContentsQuickAccessLayoutEnum.SingleRow;

    toJSON() {
        return { ...this };
    }
}
